import { Field, Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Button, Text } from '@kanda-libs/ks-design-library';
import useTradingNameForm from './useTradingNameForm';

const TradingNameForm: React.FunctionComponent = function ({}) {
  const { form, onSubmit, isLoading, isSubmitting } = useTradingNameForm();
  return (
    <FormTheme variant="streamline">
      <Form
        form={form}
        onSubmit={onSubmit}
        id="my-account-company-information-trading-name-form"
      >
        <div className="flex flex-col">
          <Text
            text="Trading Name"
            className="text-14-22-em text-neutral-900 mb-4"
            isLoading={isLoading}
          />
          <Field.Input name="trading_name" isLoading={isLoading} />
          <Button.Text
            submit
            id="my-account-company-information-trading-name-submit"
            label="Update Trading Name"
            size={40}
            className="ml-auto"
            disabled={isSubmitting}
          />
        </div>
      </Form>
    </FormTheme>
  );
};

export default TradingNameForm;
